// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__ZsahM","fileBtn":"File_fileBtn__29HC1","closeBtn":"File_closeBtn__yrSmD","fileSelected":"File_fileSelected__1UhkN","disabled":"File_disabled__30_7n"};